import { Directive, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';

@Directive({
  standalone: false,
  selector: '[requiredAsterisk]'
})
export class RequiredAsteriskDirective implements OnInit {
  _isDisabled: boolean;
  _isRequired = true;
  @Input() titleStr = '';

  get isDisabled(): boolean {
    return this._isDisabled;
  }

  @Input() set isDisabled(value: boolean) {
    this._isDisabled = value;
    this.setColorStyles();
  }

  get isRequired(): boolean {
    return this._isRequired;
  }

  @Input() set isRequired(value: boolean) {
    this._isRequired = value;
    if (value && !this.asteriskSpanEl) {
      this.createSpanElement();
    } else {
      this.toggleAsteriskSpan = value;
    }
  }

  @Input() set toggleAsteriskSpan(value: boolean) {
    if (this.asteriskSpanEl) {
      if (value) {
        this.asteriskSpanEl.style.visibility = 'visible';
      } else {
        this.asteriskSpanEl.style.visibility = 'hidden';
      }
    }
  }

  private asteriskSpanEl: HTMLElement;
  constructor(private renderer: Renderer2, private elementRef: ElementRef) { }

  ngOnInit(): void {
    if (this.isRequired && !this.asteriskSpanEl) {
      this.createSpanElement();
    }
  }

  createSpanElement() {
    this.asteriskSpanEl = this.renderer.createElement('span');
    this.asteriskSpanEl.innerHTML = '*';
    this.asteriskSpanEl.setAttribute("style", "color: #cc0000; font-weight: 500; font-family: Roboto, sans-serif; line-height: normal;");
    this.asteriskSpanEl.setAttribute('title', this.titleStr);
    this.asteriskSpanEl.className = 'required-asterisk-span';
    if (this.isDisabled) {
      this.asteriskSpanEl.style.color = "#aaaaaa";
    }
    this.renderer.appendChild(this.elementRef.nativeElement, this.asteriskSpanEl);
  }

  setColorStyles() {
    if (this.asteriskSpanEl) {
      if (this.isDisabled) {
        this.asteriskSpanEl.style.color = "#aaaaaa";
      } else {
        this.asteriskSpanEl.style.color = '#cc0000';
      }
    }
  }

}
